import { GetAllConfigMapsReq, GetAllConfigMapsRes, GetConfigMapReq, GetConfigMapRes, UpdateConfigMapReq, UpdateConfigMapRes } from '../interfaces/configMap.interface';
import {API} from './api'



export const getAllConfigMapService = async (data: GetAllConfigMapsReq): Promise<GetAllConfigMapsRes>=>{
    try {
        const res = await API.get('/v1/config-map');
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getConfigMapByKeyService = async (data: GetConfigMapReq): Promise<GetConfigMapRes>=>{
    try {
        const res = await API.get(`/v1/config-map/${data.key}`);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const getLogoConfigMapByKeyService = async (data: GetConfigMapReq): Promise<GetConfigMapRes>=>{
    try {
        const res = await API.get(`/v1/config-map/logo`);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const updateConfigMapService = async (data: UpdateConfigMapReq): Promise<UpdateConfigMapRes>=>{
    try {
        const res = await API.put('/v1/config-map', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

export const updateLogoConfigMapService= async (data: UpdateConfigMapReq, file: any): Promise<UpdateConfigMapRes>=>{
    try {

        const formData = new FormData();
        formData.append('file', file);
        formData.append('key', data.key);
        const res = await API.put('/v1/config-map/logo', formData);
        return res.data;
    } catch (error) {
        throw error
    }
}

